import { use } from 'react';
import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';

import CareConnectSettingsProviderContext from 'features/care-connect-settings/contexts/care-connect-settings-provider-context';
import styles from 'features/care-connect-settings/views/components/call-plan-label/call-plan-label.module.scss';

const CallPlanLabel = (): React.JSX.Element => {
  const { t } = useTranslation('careConnectSettings', { keyPrefix: 'callPlanLabel' });
  const { callPlanDetails } = use(CareConnectSettingsProviderContext);
  const { callPlanForm, isEditing, readCallPlanData } = callPlanDetails;

  return (
    <div className={styles.container}>
      <Typography variant="h5">{t('title')}</Typography>
      {isEditing ? (
        <Controller
          name="label"
          control={callPlanForm.control}
          rules={{ required: t('fieldRequired') }}
          render={({ field, fieldState: { error } }) => (
            <TextField {...field} error={!!error} fullWidth helperText={error?.message} value={field.value ?? ''} variant="outlined" />
          )}
        />
      ) : (
        <Typography variant="subtitle1">{readCallPlanData?.label}</Typography>
      )}
    </div>
  );
};

export default CallPlanLabel;
